import axios from "axios";
import React, {useEffect, useState} from 'react'
import FirstScreenSlider from "./first-screen/firstscreen-slider";
import Footer from "./parts/footer";
import CustomGallery from "./gallery/gallery";
import Formats from "./formats/formats";
import AdvantagesOne from "./advantages/advantages";
import Awarding from "./awarding/awarding";
import LeadMagnetOne from "./leadmagnet/leadmagnet-one";
import EbAutOne from "./ebaut-event/ebaut";
import Header from "./parts/header";
import EventThemesBase from "./themes/themes-base";
import EventSpeacersBase from "./speacers/speacers-base"
import EventPartnersBase from "./partners/partners-base"
import PartnersTopNew from "./partners/partners-top-new"
import EventPanelBase from "./panel/panel-base";
import EventProgram from "./program/program-base"
import FirstScreen from "./first-screen/firstscreen";

function HomeEn() {

    const [post, setPosts] = useState([]);

    const fetchPosts = () => {
        axios
            .get('https://ekonomika.ua/wp-json/wp/v2/events/2461?_fields=acf&acf_format=standard')
            .then((res) => {
                setPosts(res.data.acf);
            });
    }

    useEffect(() => {
        fetchPosts()
    }, [post.data])

    let advantagesData = post.advantages
    let ebautData = post.ebaut_event
    let fsData = post.fs_group
    let formatsData = post.formats
    let myGallery = post.gallery
    let awardingData = post.awarding
    let speacersData = post.speacers
    let partnersBaseData = post.partners_bottom
    let partnersTopData = post.partners_top_new
    let panelData = post.panel
    let themesData = post.theme
    let programData = post.program

    // console.log(post)

    return (
        <>
            <Header/>
            <FirstScreen fsData={fsData} />
            {/*<PartnersTopNew partnersTopData={partnersTopData} />*/}
            <EbAutOne ebautData={ebautData} />
            <EventThemesBase themesData={themesData} />
            {/*<EventPanelBase panelData ={panelData}  />*/}
            {/*<AdvantagesOne advantagesData={advantagesData} />*/}
            <EventSpeacersBase speacersData={speacersData} />
            {/*<EventProgram programData={programData} />*/}
            <Formats formatsData={formatsData} />
            {/*<Awarding awardingData={awardingData} />*/}
            {/*<CustomGallery myGallery={myGallery} />*/}
            {/*<LeadMagnetOne />*/}

            {/*<EventPartnersBase partnersBaseData={partnersBaseData}/>*/}
            <Footer />
        </>
    )
}

export default HomeEn;